import { useLayoutEffect, useState } from 'react';

/**
 * A custom hook for keeping track of current screen width
 * Inspired by https://stackoverflow.com/a/19014495
 */
function useWindowWidth(): number {
  const [windowWidth, setWindowWidth] = useState(0);
  useLayoutEffect(() => {
    const updateWidth = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', updateWidth);
    updateWidth();
    return () => window.removeEventListener('resize', updateWidth);
  }, []);
  return windowWidth;
}

export default useWindowWidth;
